// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#admin-app-bar .v-tabs-slider{max-width:24px;margin:0 auto}#admin-app-bar .v-tab:before{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
